export const StatCard = ({ label, value, sub, icon: Icon, testId, tone = "text-slate-50", delay = 0 }) => (
  <div data-testid={testId} style={{ animationDelay: `${delay}ms` }}
    className="rise bg-[#0F172A] border border-slate-800 rounded-xl p-5 hover:border-slate-600 transition-colors">
    <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-wider text-slate-400">
      {label} {Icon && <Icon className="h-4 w-4 text-slate-500" />}
    </div>
    <div className={`font-heading text-3xl font-semibold mt-3 ${tone}`}>{value}</div>
    {sub && <div className="text-xs text-slate-500 mt-1 truncate">{sub}</div>}
  </div>
);
